import '../../../../assets/citroen-font.css';
import '../../assets/third-party-css/index.css';
import '../../components/button/citroen/cit-button';
import { citroenTheme } from '../../styles/citroen/citroen-theme';
import { BrandDescriptor, ModuleDescriptor } from './brand-loader';

const citroenModules: ReadonlyArray<ModuleDescriptor> = Object.freeze([
  {
    externalName: 'VACS',
    entryPoint: async () => {
      await import('../../../location/common/common-location');
      await import('../../components/input/slider/general/slider-common');
      await import('../../components/input/text-input/general/contact-form-input-elements');
      await import('../../components/thank-you-page/common/thank-you-page-elements');
      await import('../../../vacs/common/common-vacs');
      return import('../../../vacs/citroen/cit-vacs').then((vacs) => vacs.VACS);
    },
    labelPrefix: 'vacs',
  },
  {
    externalName: 'WelcomeTextWidget',
    entryPoint: async () => {
      await import('../../../welcome-text/common/common-welcome-text-widget');
      return import('../../../welcome-text/citroen/cit-welcome-text-widget').then((wtw) => wtw.WelcomeTextWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'LocationWidget',
    entryPoint: async () => {
      await import('../../../location/common/common-location');
      await import('../../../location/citroen/common/cit-common-location');
      return import('../../../location/citroen/cit-location-widget').then((loc) => loc.LocationWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'Location',
    entryPoint: async () => {
      await import('../../components/thank-you-page/common/thank-you-page-elements');
      await import('../../../location/common/common-location');
      await import('../../../location/citroen/common/cit-common-location');
      return import('../../../location/citroen/cit-location').then((loc) => loc.LocationPage);
    },
    labelPrefix: 'location',
  },
  {
    externalName: 'OfferWidget',
    entryPoint: async () => {
      await import('../../../offer-widget/common/common-offer-widget');
      await import('../../components/single-car-offer/citroen/single-car-offer');
      return import('../../../offer-widget/citroen/cit-offer-widget').then((ow) => ow.CitOfferWidgetComponent);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'Article',
    entryPoint: async () => {
      await import('../../../article/common/common-article');
      return import('../../../article/citroen/cit-article').then((art) => art.ArticlePage);
    },
    labelPrefix: 'article',
  },
  {
    externalName: 'Advisor',
    entryPoint: async () => {
      await import('../../../advisor/common/common-advisor');
      return import('../../../advisor/citroen/cit-advisor').then((adv) => adv.Advisor);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'Showroom',
    entryPoint: async () => {
      await import('../../../showroom/common/common-showroom');
      await import('../../components/single-car-offer/citroen/single-car-offer');
      return import('../../../showroom/citroen/cit-showroom').then((showroom) => showroom.CitShowroom);
    },
    labelPrefix: 'showroom',
  },
  {
    externalName: 'ModShowroom',
    entryPoint: async () => {
      await import('dompurify');
      await import('../../../showroom/common/common-showroom');
      return import('../../../showroom/citroen/v2/cit-showroom_v2').then((showroom) => showroom.CitShowroomV2Component);
    },
    labelPrefix: 'showroom',
  },
  {
    externalName: 'CatwalkWidget',
    entryPoint: async () => {
      await import('../../../catwalk-widget/common/common-catwalk-widget');
      return import('../../../catwalk-widget/citroen/cit-catwalk-widget').then((catwalk) => catwalk.CitCatwalkWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'CarSearchWidget',
    entryPoint: async () => {
      await import('../../components/input/slider/general/slider-common');
      await import('../../../car-search-widget/common/common-car-search-widget');
      return import('../../../car-search-widget/citroen/cit-car-search-widget').then((csw) => csw.CarSearchWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'CommonForm',
    entryPoint: async () => {
      // await import('../../../common/form/controls/text/common-text-input');
      // return import('../../../common/form/common/common-form').then((loc) => loc.CommonForm)
      await import('dompurify');
      await import('classnames');
      await import('resize-observer-polyfill');
      await import('../../../vacs/common/vehicle-list.service');
      return import('../../../common/form/citroen/cit-form').then((loc) => loc.CitForm);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'Webform',
    entryPoint: async () => {
      await import('dompurify');
      await import('classnames');
      await import('resize-observer-polyfill');
      await import('../../../location/common/common-location');
      await import('../../../common-form-widget/common-form-index-widget');
      return import('../../../common-form-widget/citroen/cit-common-form-widget').then(
        (cfw) => cfw.CitCommonFormWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidget',
    entryPoint: async () => {
      await import('../../../location/common/common-location');
      await import('../../../standard-pro-widget/citroen/citroen-standard-pro-image-and-text-widget');
      await import('../../../standard-pro-widget/citroen/citroen-standard-pro-downloads-widget');
      await import('../../../standard-pro-widget/citroen/citroen-standard-pro-banner-widget');
      return import('../../../standard-pro-widget/citroen/citroen-standard-pro-widget').then(
        (spw) => spw.CitroenStandardProWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetGallery',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/citroen/citroen-standard-pro-gallery-widget').then(
        (spw) => spw.CitroenStandardProWidgetGallery
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetBanner',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/citroen/citroen-standard-pro-banner-widget').then(
        (spw) => spw.CitroenStandardProWidgetBanner
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetDownloads',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/citroen/citroen-standard-pro-downloads-widget').then(
        (spw) => spw.CitroenStandardProWidgetDownloads
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetText',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/citroen/citroen-standard-pro-text-widget').then(
        (spw) => spw.CitroenStandardProWidgetText
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetImageAndText',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/citroen/citroen-standard-pro-image-and-text-widget').then(
        (spw) => spw.CitroenStandardProWidgetImageAndText
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetMultipleImageAndText',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/citroen/citroen-standard-pro-multi-image-and-text-widget').then(
        (spw) => spw.CitroenStandardProWidgetMultiImageAndText
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetTable',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/citroen/citroen-standard-pro-table-widget').then(
        (spw) => spw.CitroenStandardProWidgetTable
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetVideo',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/citroen/citroen-standard-pro-video-widget').then(
        (spw) => spw.CitroenStandardProWidgetVideo
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetTabs',
    entryPoint: async () => {
      await import('../../../standard-pro-widget/citroen/citroen-standard-pro-image-and-text-widget');
      await import('../../../standard-pro-widget/citroen/citroen-standard-pro-downloads-widget');
      await import('../../../standard-pro-widget/citroen/citroen-standard-pro-banner-widget');
      await import('../../../standard-pro-widget/citroen/citroen-standard-pro-video-widget');
      return import('../../../standard-pro-widget/citroen/citroen-standard-pro-tabs-widget').then(
        (spw) => spw.CitroenStandardProWidgetTabs
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'LeasingAndUsedCarsWidget',
    entryPoint: async () => {
      await import('../../components/input/slider/general/slider-common');
      await import('../../../leasing-and-used-cars-widget/common/common-leasing-and-used-cars-widget');
      return import('../../../leasing-and-used-cars-widget/citroen/citroen-leasing-and-used-cars-widget').then(
        (so) => so.CitroenLeasingAndUsedCarsWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'TestPageWidget',
    entryPoint: async () => {
      return import('../../../test-page/citroen/cit-test-page-widget').then((tpw) => tpw.TestPageWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'BannerWidget',
    entryPoint: async () => {
      return import('../../../banner/citroen/citroen-banner-widget').then((banner) => banner.CitBannerWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'FooterWidget',
    entryPoint: async () => {
      return import('../../../footer/citroen/citroen-footer-widget').then((footer) => footer.FooterWidget);
    },
    labelPrefix: 'widget',
  },
]);

export default [citroenModules, citroenTheme] as BrandDescriptor;
